
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_18moy_5",
  "has-items": "awsui_has-items_dm8gx_18moy_14",
  "token": "awsui_token_dm8gx_18moy_18",
  "dismiss-button": "awsui_dismiss-button_dm8gx_18moy_30",
  "token-disabled": "awsui_token-disabled_dm8gx_18moy_64",
  "toggle": "awsui_toggle_dm8gx_18moy_78",
  "description": "awsui_description_dm8gx_18moy_135"
};
  